/* S20-173: priority navigation for the desktop main menu row.
   Hides top-level links in the "Menu drop order" (header section setting) as the
   row narrows; if it still doesn't fit, hides all links + pill buttons and only
   the utility hamburger remains. Measured, not breakpoint-based. Matching is on
   the link's visible text (case/spacing ignored). */
(() => {
  const row = document.querySelector('#main-nav .navigation-bar__row');
  if (!row) return;
  const container = row.querySelector('.navigation__tier-1-container');
  const list = container && container.querySelector('.navigation__tier-1');
  if (!list) return;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const items = [...list.children].filter((li) => li.classList.contains('navigation__item'));
  const titleOf = (li) => {
    const a = li.querySelector(':scope > .navigation__link');
    return norm(a ? a.textContent : '');
  };
  const order = (row.dataset.elDropOrder || '').split(',').map(norm).filter(Boolean);
  const dropQueue = order.map((t) => items.find((li) => titleOf(li) === t)).filter(Boolean);

    // Compare the right edge of the last visible top-level link with the right
  // edge of the menu area. (Not list.scrollWidth: that also counts the hidden
  // dropdown panels, which made the menu look far wider than it is.)
  const overflowing = () => {
    const visible = items.filter((li) => !li.classList.contains('el-nav-dropped'));
    const last = visible[visible.length - 1];
    if (!last) return false;
    return last.getBoundingClientRect().right > container.getBoundingClientRect().right + 1;
  };

  let raf = 0;
  function fit() {
    raf = 0;
    if (!row.offsetParent) return; // desktop only
    row.classList.remove('el-nav--collapsed');
    items.forEach((li) => li.classList.remove('el-nav-dropped'));
    for (const li of dropQueue) {
      if (!overflowing()) break;
      li.classList.add('el-nav-dropped');
    }
    if (overflowing()) row.classList.add('el-nav--collapsed');
  }
  const schedule = () => { if (!raf) raf = requestAnimationFrame(fit); };

  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(row);
  else window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  schedule();
})();